import React, { FC, useMemo } from "react";
import { MdDownload } from "react-icons/md";

import { Item } from "../../models/item.type";
import useFileTypeQualifier from "../../hooks/use-file-type-qualifier";

import noPreviewImage from "../../resources/images/media.png";
import VideoImage from "../../resources/images/video.png";
import Video360Image from "../../resources/images/video-360.png";
// import PhotoImage from "../../resources/images/photo.png";

import styles from "./media-file.module.css";

export type FileItem = Item & { check: boolean };

type MediaFileProps = {
  item: FileItem;
};

const MediaFile: FC<MediaFileProps> = (props) => {
  const { item } = props;
  const qualifier = useFileTypeQualifier();

  const filePreview = useMemo(() => {
    if (qualifier.isVideo(item.file_link)) {
      if (item.file_link.includes(".360.")) {
        return Video360Image;
      } else {
        return VideoImage;
      }
    } else if (item.file_link) {
      return item.file_link;
    } else {
      return item.preview;
    }
  }, [item.file_link, item.preview, qualifier]);

  const renderFile = (
    <div>
      <img
        onError={(event) => changeImageIfExists(event)}
        className={styles.image}
        src={filePreview}
        alt=""
      />
    </div>
  );

  function changeImageIfExists(event) {
    event.target.src = noPreviewImage;
  }

  return (
    <div className={styles.container}>
      {renderFile}
      <div className={styles.downloadButtonContainer}>
        <div className={styles.downloadButton}>
          <a href={item.file_link}>
            <div className={styles.downloadButtonInner}>
              <MdDownload color={"white"} size={20} />
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default MediaFile;
